import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";
export var api__createAmwalRemainingCheckout = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(requestData) {
    var response;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetcher().post("/amwal/checkout-remaining-payment", requestData);
        case 1:
          response = _context.v;
          return _context.a(2, response.data);
      }
    }, _callee);
  }));
  return function api__createAmwalRemainingCheckout(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__getAmwalRemainingOrderStatus = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(requestData) {
    var _response$data;
    var response;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return fetcher().post("/amwal/get-order-details", requestData);
        case 1:
          response = _context2.v;
          if (!(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.success)) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, response.data);
        case 2:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return function api__getAmwalRemainingOrderStatus(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var api__cancelAmwalRemainingOrder = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(requestData) {
    var _response$data2;
    var formData, response;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          formData = new URLSearchParams();
          formData.set("order_id", String(requestData.order_id));
          formData.set("status", requestData.status);
          _context3.n = 1;
          return fetcher().post("/amwal/cancel-order", formData);
        case 1:
          response = _context3.v;
          if (!(response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.success)) {
            _context3.n = 2;
            break;
          }
          return _context3.a(2, response.data);
        case 2:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return function api__cancelAmwalRemainingOrder(_x3) {
    return _ref3.apply(this, arguments);
  };
}();